export default abstract class Functions {
  abstract convert_file_to_base_64(input_file: File): Promise<string | ArrayBuffer | null>;

  abstract convert_base_64_to_file(ase64: string, mime_type: string, filename: string):
    Promise<File>;
}
